import React from "react";
import { Col } from "react-bootstrap";
import { CardItem } from "../../../CommonElements/Card";

const ArrivalCardSkeleton = () => {
  return <Col xs={12} md={6} xl={4}>
    <ArrivalCardSkeletonNoCol />
  </Col>;
};

export const ArrivalCardSkeletonNoCol = () => {
  return (
    <CardItem>
      <CardItem.Header>
        <div style={{ marginBottom: "16px" }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div
              className="skeleton"
              style={{ height: "24px", width: "120px" }}
            ></div>
            <div
              className="skeleton"
              style={{ height: "28px", width: "100px", borderRadius: "16px" }}
            ></div>
          </div>
          <div
            className="skeleton"
            style={{ height: "20px", width: "80px" }}
          ></div>
        </div>
      </CardItem.Header>

      <div className="row">
        <div className="col-12 col-md-6 p-2">
          <div
            className="skeleton"
            style={{ height: "16px", width: "80px", marginBottom: "4px" }}
          ></div>
          <div
            className="skeleton"
            style={{ height: "20px", width: "40px" }}
          ></div>
        </div>
        <div className="col-12 col-md-6 p-2">
          <div
            className="skeleton"
            style={{ height: "16px", width: "100px", marginBottom: "4px" }}
          ></div>
          <div
            className="skeleton"
            style={{ height: "20px", width: "30px" }}
          ></div>
        </div>
        <div className="col-12 col-md-6 p-2">
          <div
            className="skeleton"
            style={{ height: "16px", width: "60px", marginBottom: "4px" }}
          ></div>
          <div
            className="skeleton"
            style={{ height: "20px", width: "90px" }}
          ></div>
        </div>
        <div className="col-12 col-md-6 p-2">
          <div
            className="skeleton"
            style={{ height: "16px", width: "100px", marginBottom: "4px" }}
          ></div>
          <div
            className="skeleton"
            style={{ height: "20px", width: "140px" }}
          ></div>
        </div>
        <div className="col-12 col-md-6 p-2">
          <div
            className="skeleton"
            style={{ height: "16px", width: "110px", marginBottom: "4px" }}
          ></div>
          <div
            className="skeleton"
            style={{ height: "20px", width: "120px" }}
          ></div>
        </div>
        <div className="col-12 col-md-6 p-2">
          <div
            className="skeleton"
            style={{ height: "16px", width: "80px", marginBottom: "4px" }}
          ></div>
          <div
            className="skeleton"
            style={{ height: "20px", width: "50px" }}
          ></div>
        </div>
        <div className="col-12 col-md-6 p-2">
          <div
            className="skeleton"
            style={{ height: "16px", width: "100px", marginBottom: "4px" }}
          ></div>
          <div
            className="skeleton"
            style={{ height: "20px", width: "130px" }}
          ></div>
        </div>
      </div>

      <CardItem.Footer>
        <div
          className="d-flex justify-content-between align-items-center pt-3"
          style={{ gap: "16px" }}
        >
          <div
            className="skeleton flex-fill"
            style={{ height: "40px", borderRadius: "6px" }}
          ></div>
          <div
            className="skeleton flex-fill"
            style={{ height: "40px", borderRadius: "6px" }}
          ></div>
        </div>
      </CardItem.Footer>
    </CardItem>
  );
};

export default ArrivalCardSkeleton;
